import { createSlice, Dispatch } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type InitialStateType = {
  appType: string;
};

const initialState: InitialStateType = {
  appType: 'web',
};

export const appInitialization = createSlice({
  name: 'appInfo',
  initialState,
  reducers: {
    defineDesktopApp(state) {
      state.appType = 'desktop';
    },
  },
});

const { defineDesktopApp } = appInitialization.actions;

export const initializeApp = (dispatch: Dispatch) => {
  dispatch(defineDesktopApp());
  // something else in the future
};

export const selectAppType = (state: RootState) => state.appInfo.appType;

export const appIsDesktop = (state: RootState) =>
  state.appInfo.appType === 'desktop';

export const appIsWeb = (state: RootState) => state.appInfo.appType === 'web';

export default appInitialization.reducer;
